export default __webpack_public_path__ + "static/media/suggestion-chips-watson-dialog3.ee5c5e90.png";